import { Component, OnInit } from '@angular/core'
import { onsNotification } from 'ngx-onsenui'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { RestServices } from '../../services/rest.services'
import { AuthService } from '../../services/auth.services'
import { SharedServices } from '../../services/shared.services'
import { CookieService } from 'ngx-cookie-service'
import { versionApp, versionWeb } from '../../../helper/common'
import { NotificationService } from '@app/services'
import { RequestServices } from '@services/request.services'

import * as moment from 'moment'
declare var cordova: any

@Component({
    selector: 'ons-page[tabSetting]',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.css',
        '../../stagingcss/main-body.component.css',
        '../../stagingcss/lui-select.component.css'],
})
export class SettingComponent implements OnInit {
    versionWeb = versionWeb
    versionApp = versionApp
    clientId
    clientInfo = {
        familyName: null,
        firstName: null,
    }
    previewMode = false
    showOption: any
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    optionArr = [{ id: 1, name: 'English', lang: 'true' }, { id: 2, name: '日本語', lang: 'false' }]
    en: any = {}
    showEN = true
    styleVisibility: any


    constructor(private route: ActivatedRoute, private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private cookieService: CookieService
        , private notificationService: NotificationService, private requestService: RequestServices) {
        _sharedService.changeEmittedSource$.subscribe(
            success => {
                //
                this.clientInfo = success[0]
            },
        )
        this._sharedService.changeEmitted$.subscribe(
            res => {
                if (res[0] == 'changePageMobileApp' && res[1] === 4) {
                    this.getInfoClient()
                }
            })
    }

    ngOnInit() {
        if (this.langDefault) {
            this.styleVisibility = { visibility: 'visible' }
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.clientId = id
            //
        })
        if (this.route.url['value'][3] && this.route.url['value'][3].path == 'preview') {

            this.previewMode = true
        }
        this.changeLanguage()
    }

    getInfoClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map: { [this.clientId]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    // this.listDoctor = success['response']['staff']['paths']['{"roles":"doctor"}'];

                    this.clientInfo = success['response']['client']['map'][this.clientId]
                },
            )
        })
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
        }, 100)
    }

    logoutButton() {
        if (localStorage.lang != 'false') {
            onsNotification.confirm(
                {
                    message: 'Are you sure to logout?',
                    title: '<b>Logout</b>',
                    buttonLabels: ['Cancel', 'OK'],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.

                            this.logoutToken()
                        }
                    },
                })
        } else {
            onsNotification.confirm(
                {
                    message: '本当にログアウトしますか?',
                    title: '<b>ログアウト</b>',
                    buttonLabels: ['戻る', 'OK'],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.

                            this.logoutToken()
                        }
                    },
                })
        }
    }

    logoutToken() {
        if (!this.previewMode) {
            if (localStorage.getItem('device_token')) {
                this.requestService.httpPost('websocket/delete-device-token', {
                    clientId: this.clientId,
                    deviceToken: localStorage.getItem('device_token'),
                })
                .subscribe(res => {
                    this.removeCookieData();
                })
            } else {
               this.removeCookieData(false);
            }
        } else {
            this.router.navigateByUrl('client/login-token/preview')
        }
    }
    private removeCookieData(isRemoveDeviceToken = true) {
        let resourceData = {
            line_code: "client-app/setting/setting.component.ts line 169",
            reason: "User log out",
            token: this.authData.getItem('token'),
            date: Date.now()
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('account/clientLog', resourceData, tokenReNew).subscribe(res => {
                console.log('logcat client logout')
                localStorage.removeItem('user')
                localStorage.removeItem('token')
                localStorage.removeItem('timeout')
                this.cookieService.delete('token')
                if (isRemoveDeviceToken) {
                    localStorage.removeItem('device_token')
                }
                this.router.navigateByUrl('client/login-token')

            })
        })





    }

    selectOption(id, langChang) {
        this.showOption = 'showOption_' + id
        if (this.showOption || this.langDefault === langChang) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('account/lang', { lang: id == 1 ? 'en' : 'ja' }, tokenReNew).subscribe(res => {
                    if(res['success']){
                        this.styleVisibility = { visibility: 'visible' }
                        localStorage.setItem('lang', langChang)
                        this.langDefault = langChang
                        this.changeLanguage()
                        if (localStorage.getItem("device_token")) {
                            const resourceUrl = 'resource'
                            const updateData = {}
                            const platform = window.navigator.userAgent.match(/iOS|iPhone|iPad/)
                                ? 'ios'
                                : 'android'
                            const lastLogin = moment().unix()
                            const lang = this.authData.getLang()
                            const token = localStorage.getItem("device_token");
                            const clientDeviceId = this.authData.getUser().clientDeviceId

                            updateData[`deviceToken.${ localStorage.getItem("device_token") }`] = {
                                token,
                                clientDeviceId,
                                platform,
                                lastLogin,
                                lang,
                            }
                            const resourceData = {
                                actions: [
                                    {
                                        collection: 'client',
                                        id: this.clientId,
                                        type: 'update',
                                        value: updateData,
                                    },
                                ],
                                status: {
                                    client: {
                                        map: { [this.clientId]: true },
                                    },
                                },
                            }
                            this.authData.authToken().then((tokenReNew) => {
                                this.restApi
                                .http_post(resourceUrl, resourceData, tokenReNew)
                                .subscribe((success) => {
                                    console.log(success)
                                })
                            })
                        }
                    }
                })
            })

        }

    }

    openProlicy(){
        const location = window.location.origin + "/privacy_statement/policy.html"
        cordova.InAppBrowser.open(location, '_system', 'location=yes')
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

}




// WEBPACK FOOTER //
// ./src/app/client-app/setting/setting.component.ts